module.exports = __webpack_public_path__ + "1f545eb99b323d22b91e51b9e56df808.svg";